var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChanges = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.875 5.562H3.449A7.219 7.219 0 0 1 16.72 9.5h1.312A8.531 8.531 0 0 0 2.938 4.04V1.625H1.625v5.25h5.25zm5.25 7.875h3.426A7.219 7.219 0 0 1 2.28 9.5H.97a8.531 8.531 0 0 0 15.094 5.46v2.415h1.312v-5.25h-5.25z",
  clipRule: "evenodd"
})));
export default SvgChanges;